import { setDefaults as a } from "./index87.mjs";
const i = {
  type: "3rdParty",
  init(t) {
    a(t.options.react);
  }
};
export {
  i as initReactI18next
};
